<!--
// app/components/pages/region-domain/FaqItem.vue
-->
<script setup lang="ts">
type Props = {
  title: string;
  content: string;
};

defineProps<Props>();

const contentOpen = ref(false);
</script>

<template>
  <div>
    <div id="faqs-accordion-heading-1">
      <button
        type="button"
        class="flex items-center justify-start gap-2 text-left w-full py-4 text-gray-400 border-b border-gray-600"
        @click="contentOpen = !contentOpen"
        :aria-expanded="contentOpen"
        aria-controls="faqs-accordion-body-1"
      >
        <svg
          class="hidden sm:block min-w-4 min-h-4 w-4 h-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm0 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm1-5.034V12a1 1 0 0 1-2 0v-1.418a1 1 0 0 1 1.038-.999 1.436 1.436 0 0 0 1.488-1.441 1.501 1.501 0 1 0-3-.116.986.986 0 0 1-1.037.961 1 1 0 0 1-.96-1.037A3.5 3.5 0 1 1 11 11.466Z"
          />
        </svg>
        <h3 :class="[contentOpen ? 'text-white !font-medium' : 'text-gray-400', '!text-lg !mt-0']">
          {{ title }}
        </h3>
        <svg
          data-accordion-icon
          :class="[
            'w-6 h-6 shrink-0 transition-transform ease-in-out duration-300 ml-auto',
            contentOpen ? '-rotate-180' : 'rotate-0',
          ]"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </button>
    </div>
    <div
      id="faqs-accordion-body-1"
      :class="contentOpen ? 'block' : 'hidden'"
      aria-labelledby="faqs-accordion-heading-1"
    >
      <div class="py-5 text-gray-400" v-html="content"></div>
    </div>
  </div>
</template>

<style scoped></style>
